import axiosInstance from "../../../api/axiosInstance";

let episodeRequest = 0;

export default {
  namespaced: true,
  state: {
    episodes: [],
    episode: {},
  },
  actions: {
    async lockEpisode({}, { id, locked, class_room_id }) {
      await axiosInstance.put(`/episodes/${id}/lock`, {
        locked,
        class_room_id,
      });
    },
    async loadEpisodes({ commit, state }) {
      const response = await axiosInstance.get("/episodes");
      commit("setEpisodes", response.data);
    },
    async loadEpisode({ commit }, payload) {
      const { id, preview } = typeof payload === "object" ? payload : { id: payload };
      const request = ++episodeRequest;
      commit("setEpisode", {});
      const response = await axiosInstance.get(`/episodes/${id}`, { params: { preview: preview ? "true" : undefined } });
      if (request !== episodeRequest) return;
      commit("setEpisode", response.data);
      return response;
    },
  },
  mutations: {
    setEpisodes(state, episodes) {
      state.episodes = episodes;
    },
    setEpisode(state, episode) {
      state.episode = episode;
    },
  },
  getters: {
    episodes: (state) => state.episodes,
    episode: (state) => state.episode,
  },
};
